<template>
  <div class="boxbgcolor parking-space">
    <div class="left content-left">
      <ShareParkingTree
        v-on:handleTreeClick="handleTreeClick"
        moduleName="parking"
        shareType="personal"
      ></ShareParkingTree>
    </div>
    <div class="right content-right list">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <div class="form-group">
            <label for>停车场:</label>
            <el-select v-model="search.parkingId" style="width:180px">
              <el-option
                v-for="item in shareParksData"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              ></el-option>
            </el-select>
          </div> -->
          <!-- <div class="form-group">
            <label>车位类型:</label>
            <el-select
              v-model="search.parkingType"
              placeholder="请选择车位类型"
              clearable
            >
              <el-option
                v-for="(key, value) in spaceTypes"
                :key="key"
                :label="key"
                :value="value"
              >
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="form-group">
            <label>审核状态:</label>
            <el-select
              v-model="search.auditStatus"
              placeholder="请选择审核状态"
              clearable
            >
              <el-option
                v-for="(key, value) in auditStatusType"
                :key="key"
                :label="key"
                :value="value"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="form-group">
            <label>车位号:</label>
            <input
              v-model="search.parkingUniqueId"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="tableLoading"
              >
                查询
              </el-button>
            </span>
            <!-- <span class="search_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                批量导入
              </button>
            </span> -->
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="onPendingSpaceClick"
              >
                待完善车位
              </button>
            </span>
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="onPendingAuditClick"
              >
                待审核车位
              </button>
            </span>
            <span class="batchImport_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="onPendingDeleteClick"
              >
                待删除车位
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-if="search.parkingId"
            v-loading="tableLoading"
          >
            <el-table-column
              show-overflow-tooltip
              label="归属停车场"
              prop="parkingName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="客户名称"
              prop="parkingOwner"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="楼层"
              prop="parkingLayer"
            >
            </el-table-column>
            <el-table-column show-overflow-tooltip label="区域" prop="areaName">
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车位号"
              prop="parkingUniqueId"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="联系人"
              prop="parkingOwner"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="手机号码"
              prop="parkingOwnerPhone"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车位状态"
              prop="parkingSpaceStatus"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="车位类型"
              prop="parkingType"
            ></el-table-column>
            <!-- <el-table-column
                show-overflow-tooltip
                label="营业执照"
                prop="alipay"
              ></el-table-column> -->
            <!-- <el-table-column
              show-overflow-tooltip
              label="车位是否通过审核"
              prop="auditStatus"
            ></el-table-column> -->

            <el-table-column
              show-overflow-tooltip
              label="车位锁编号"
              prop="lockId"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="审核状态">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.auditStatus == 0"
                  style="color: #67c23a; font-weight: bold"
                  >审核通过</span
                >
                <span
                  v-if="scope.row.auditStatus == 1"
                  style="color: #e6a23c; font-weight: bold"
                  >审核中</span
                >
                <span
                  v-if="scope.row.auditStatus == 2"
                  style="color: red; font-weight: bold"
                  >审核不通过</span
                >
                <!-- {{ handleAuditStatus(scope.row) }} -->
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="上下架状态">
              <template slot-scope="scope">
                <el-switch
                  v-if="scope.row.parkingType == '企业'"
                  style="display: block"
                  @change="(val) => onSwitchChange(val, scope.row)"
                  :value="scope.row.published == 1 ? true : false"
                  active-color="#13ce66"
                  inactive-color="gray"
                >
                </el-switch>
                <span v-else>
                  <span
                    v-show="scope.row.published == 1"
                    style="color: #67c23a; font-weight: bold"
                    >已上架</span
                  >
                  <span
                    v-show="scope.row.published == 2"
                    style="color: red; font-weight: bold"
                    >已下架</span
                  >
                </span>
              </template>
            </el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="添加时间"
              prop="crtTime"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="300px">
              <template slot-scope="scope">
                <!-- <button
                  v-if="property_audit_btn"
                  :style="{
                    color: scope.row.auditStatus == 1 ? '' : '#666',
                    cursor: 'pointer',
                  }"
                  class="audit operate-button"
                  @click="onAuditBtn(scope.row, 1)"
                >
                  物业审核
                </button> -->
                <button
                  v-if="platform_audit_btn && scope.row.parkingType == '个人'"
                  :style="{
                    color: scope.row.auditStatus == 1 ? '' : '#666',
                    cursor: 'pointer',
                  }"
                  class="audit operate-button"
                  @click="onAuditBtn(scope.row, 2)"
                >
                  认证详情
                </button>
                <!-- <button
                  class="audit operate-button"
                  @click="onRuleClick(scope.row)"
                >
                  收费规则
                </button> -->
                <button
                  class="audit operate-button"
                  @click="onEditBtn(scope.row)"
                  :style="scope.row.lockSpace == 0 ? 'color: #666' : ''"
                  v-if="scope.row.parkingType == '个人'"
                >
                  修改
                </button>
                <button
                  class="audit operate-button"
                  @click="onEditBtn(scope.row)"
                  :style="scope.row.lockSpace == 0 ? 'color: #666' : ''"
                  v-if="scope.row.parkingType == '企业'"
                >
                  修改
                </button>
                <button
                  class="audit operate-button"
                  @click="onSettingBtn(scope.row)"
                  :style="scope.row.lockSpace == 0 ? 'color: #666' : ''"
                  v-if="scope.row.parkingType == '企业'"
                >
                  设置
                </button>
                <button class="delete" @click="onDelSpaceBtn(scope.row)">
                  删除
                </button>

                <el-dropdown
                  class="audit operate-button"
                  @command="(e) => handleCommand(e)"
                >
                  <span
                    class="el-dropdown-link"
                    style="
                      cursor: pointer;
                      padding-left: 5px;
                      color: #278cd8;
                      font-size: 12px;
                    "
                  >
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :disabled="scope.row.lockSpace == 0"
                      :command="{ type: 'bind', ...scope.row }"
                      >车锁绑定</el-dropdown-item
                    >
                    <el-dropdown-item
                      :disabled="scope.row.lockSpace == 1"
                      :command="{ type: 'unbind', ...scope.row }"
                      >车锁解绑</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-else
            style="
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <el-empty description="请先选择左侧的停车场"></el-empty>
          </div>
        </div>
      </template>
    </div>
    <el-dialog
      title="车锁绑定"
      :visible.sync="dialogLockFormVisible"
      class="bind-lock-dialog"
    >
      <el-form :model="form">
        <!-- <el-form-item label="网关编号" :label-width="formLabelWidth">
          <el-select
            v-model="form.gatewayIds"
            placeholder="网关编号"
            @change="onGateChange"
          >
            <el-option
              v-for="item in gates"
              :key="item.gatewayId"
              :label="item.gatewaySn"
              :value="item.gatewayId"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="车位编号" :label-width="formLabelWidth">
          <el-select v-model="form.lockIds" placeholder="车位编号">
            <el-option
              v-for="item in locks"
              :key="item.lockId"
              :label="item.lockSn"
              :value="item.lockId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindLockSure">确 定</el-button>
        <el-button @click="dialogLockFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="车位修改"
      :visible.sync="dialogSpaceFormVisible"
      class="bind-lock-dialog"
    >
      <el-form :model="form">
        <el-form-item label="客户名称" :label-width="formLabelWidth">
          <el-input v-model="editForm.parkingOwner"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model="editForm.parkingOwner"></el-input>
        </el-form-item>
        <el-form-item label="所属楼层" :label-width="formLabelWidth">
          <el-input v-model="editForm.parkingLayer"></el-input>
        </el-form-item>
        <el-form-item label="区域名称" :label-width="formLabelWidth">
          <el-select v-model="editForm.areaId" >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车位号" :label-width="formLabelWidth">
          <el-input v-model="editForm.parkingUniqueId"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="editForm.parkingOwnerPhone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onEditSpaceSure">确 定</el-button>
        <el-button @click="dialogSpaceFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--批量导入车位-->
    <el-dialog
      :close-on-click-modal="false"
      title="批量导入车位"
      :visible.sync="batchImportDialogFormVisible"
      width="500px"
      @closed="closeUpload"
    >
      <div class="downloadTemplate">
        <span class="downloadButtonText">
          <span class="tip">*</span>请先
          <span @click="bulkLoadTemplate" class="downloadButton">下载模板</span
          >，按照模板要求填入数据后，再上传文件
        </span>
      </div>
      <div class="upload">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/api/onsite/share/importExcelSharedParkingSpace"
          :multiple="false"
          name="file"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileSuccess"
          :on-error="fileError"
          :data="{
            parkingId: search.parkingId,
          }"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
        <el-button @click="batchImportDialogFormVisible = false" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  shareSpaceList,
  shareParks,
  locksByGateId,
  gatesByParkingId,
  bindLock,
  delShareSpace,
  updateShareSpace,
  spacePublished,
  areasByShareParkingId,
} from "@/api/url";

import Page from "@/page/commons/page";
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
import ShareParkingTree from "@/page/commons/parking/commons/share-parking-tree.vue";
import { AUDIT_STATUS_TYPE } from "./constant";

export default {
  data() {
    return {
      spaceTypes: { 个人: "个人", 企业: "企业" },

      shareParksData: [],
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      parkingList: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      showTimeDay: true,
      showTimeMonth: false,
      auditStatusType: { ...AUDIT_STATUS_TYPE },
      echartSearch: {
        beginTime: "",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        parkingId: undefined,
        auditStatus: 0,
        parkingId: undefined,
        parkingType: "2",
        parkingUniqueId: "",
      },
      tableListData: [
        {
          id: "1",
          parkingOwner: "111",
          parkingUniqueId: "222",
          lockId: "333",
          parkingType: "444",
          auditStatus: "1",
        },
      ],
      tableListDataTitle: [],
      property_audit_btn: false,
      platform_audit_btn: false,
      dialogLockFormVisible: false,
      form: {
        gatewayIds: "",
        lockIds: "",
      },
      formLabelWidth: "120px",
      gates: [],
      locks: [],
      id: "",
      editForm: {},
      dialogSpaceFormVisible: false,
      currentSpace: {},
      batchImportDialogFormVisible: false,
      areas: [],
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((data) => {
        this.shareParksData = data?.data?.data?.rows ?? [];
      });
    },
    tableList: function (curPage) {
      if (!this.search.parkingId) {
        this.$message({ type: "error", message: "请先选择停车场" });
        return;
      }

      var _this = this;
      this.tableLoading = true;
      _this.tableListData = [];
      this.$postRequest(shareSpaceList(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.search.parkingId,
        auditStatus: this.search.auditStatus,
        parkingType: this.search.parkingType,
        parkingUniqueId: this.search.parkingUniqueId.trim(),
        //   beginTime: this.search.beginTime,
        //   endTime: this.search.endTime,
      })
        .then((data) => {
          if (data?.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },
    onAuditBtn(row, step) {
      this.$router.push({
        path: "/main/park/parking-space/audit",
        query: { space: JSON.stringify(row), step },
      });
    },
    onSettingBtn(row) {
      this.$router.push({
        path: "/main/park/parking-space/setting",
        query: { space: JSON.stringify(row) },
      });
    },
    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        // 获取数据
        this.tableList(this.search.pageNumber);
        this.getAreasByShareParkingId(node.id);
      } else this.search.parkingId = undefined;
    },
    //   async initParking() {
    //     await this.getParkingList();
    //     this.search.parkingId = this.parkingList[0].parkingId;
    //     this.tableList(this.search.pageNumber);
    //   },
    searchList() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    handleAuditStatus(data) {
      switch (data.auditStatus) {
        case 0:
          return "审核通过";

        case 1:
          return "审核中";

        case 2:
          return "审核不通过";

        default:
          return "";
      }
    },
    onRuleClick(row) {
      this.$router.push({
        path: "/main/park/parking-space/charge-rule",
        query: {
          parkingId: row.parkingId,
          areaId: row.areaId,
        },
      });
    },

    handleCommand(command) {
      this.form = {
        gatewayIds: "",
        lockIds: "",
      };
      const { type, id, gatewayId, lockId, parkingId } = command;
      this.id = id;
      switch (type) {
        case "bind":
          this.dialogLockFormVisible = true;
          this.getGates(parkingId);
          break;
        case "unbind":
          this.$postRequest(bindLock(), {
            id,
            gatewayIds: gatewayId,
            lockIds: lockId,
            status: 1,
          }).then((res) => {
            this.$message(res?.status == 200 ? "解绑成功" : res?.message ?? "");
            if (res?.status == 200) {
              this.tableList(this.curIndex);
            }
          });
          break;
        default:
          break;
      }
    },
    getGates(parkingId) {
      this.$get(`${gatesByParkingId()}/${parkingId}`).then((res) => {
        this.gates = res?.data ?? [];
      });
    },
    getLocks(gateId) {
      this.$get(`${locksByGateId()}/${gateId}`).then((res) => {
        this.locks = res?.data ?? [];
      });
    },
    onGateChange(val) {
      this.getLocks(val);
    },
    bindLockSure() {
      this.$postRequest(bindLock(), {
        ...this.form,
        id: this.id,
        status: 0,
      }).then((res) => {
        this.$message(res.status == 200 ? "绑定成功" : res?.message ?? "");
        if (res?.status == 200) {
          this.dialogLockFormVisible = false;
          this.tableList(this.curIndex);
        }
      });
    },
    onDelSpaceBtn(row) {
      const index = this.$layer.confirm(
        "确定删除该车位？",
        {
          title: "提示",
          btn: ["确定", "取消"],
        },
        () => {
          this.$layer.close(index);
          this.$deleteRequest(`${delShareSpace()}?id=${row.id}`).then((res) => {
            this.$message({
              message: res?.status == 200 ? "删除成功" : res?.message ?? "",
              type: res?.status == 200 ? "success" : "error",
            });
            if (res?.status == 200) {
              this.tableList(this.curIndex);
            }
          });
        }
      );
    },
    onEditBtn(row) {
      if (row.lockSpace == 0) {
        this.$message({
          type: "warning",
          message: `${row.parkingUniqueId}已绑定车位锁，请先解绑车位锁`,
        });
        return;
      }
      this.editForm = { ...row };
      this.dialogSpaceFormVisible = true;
    },
    onEditSpaceSure() {
      this.$postRequest(updateShareSpace(), this.editForm).then((res) => {
        this.$message({
          type: res?.status == 200 ? "success" : "error",
          message: res?.status == 200 ? "修改成功" : res?.message ?? "修改失败",
        });
        if (res?.status == 200) {
          this.dialogSpaceFormVisible = false;
          this.tableList(this.curIndex);
        }
      });
    },
    fileSuccess() {
      this.$message({
        type: "success",
        message: "文件上传成功",
      });
      this.batchImportDialogFormVisible = false;
      this.tableList(this.curIndex);
      this.$refs.upload.clearFiles();
    },
    fileError() {
      this.$message({
        type: "error",
        message: "文件上传失败",
      });
    },
    batchImport() {
      this.batchImportDialogFormVisible = true;
    },
    bulkLoadTemplate() {
      fetch("/api/onsite/share/downLoadExcelSharedParkingSpace", {
        method: "POST",
      })
        .then((response) => {
          if (response.status === 200) {
            return response.blob();
          } else {
            throw new Error("下载失败");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "批量导入车位模板.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    submitUpload() {
      this.batchImportDialogFormVisible = false;

      this.$refs.upload.submit();
    },
    closeUpload() {},
    onSwitchChange(val, row) {
      this.$putRequest(`${spacePublished()}/${row.id}`, {
        id: row.id,
        published: val ? 1 : 2,
      }).then((res) => {
        this.$message({
          type: res?.status == 200 ? "success" : "error",
          message: res?.status == 200 ? "操作成功" : res?.message ?? "操作失败",
        });
        if (res?.status == 200) {
          this.tableList(this.curIndex);
        }
      });
    },
    onPendingSpaceClick() {
      if (!this.search.parkingId) {
        this.$message({ type: "error", message: "请先选择停车场" });
        return;
      }
      this.$router.push({
        path: "/main/park/parking-space/pending",
        query: { parkingId: this.search.parkingId },
      });
    },
    onPendingDeleteClick() {
      if (!this.search.parkingId) {
        this.$message({ type: "error", message: "请先选择停车场" });
        return;
      }
      this.$router.push({
        path: "/main/park/parking-space/delete",
        query: { parkingId: this.search.parkingId },
      });
    },
    onPendingAuditClick() {
      if (!this.search.parkingId) {
        this.$message({ type: "error", message: "请先选择停车场" });
        return;
      }
      this.$router.push({
        path: "/main/park/parking-space/audit-pending",
        query: { parkingId: this.search.parkingId },
      });
    },
    getAreasByShareParkingId(id) {
      this.$get(`${areasByShareParkingId()}/${id}`, {}).then((res) => {
        if (res.status == 200) {
          this.areas = res.data ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.property_audit_btn = this.elements["property_audit"];
      this.platform_audit_btn = this.elements["platform_audit"];
    },
  },
  components: {
    Page,
    ShareParkingTree,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.search.pageNumber = 1;
    // this.tableList(1);
    // this.getShareParks();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
</style>
<style>
.bosk-table .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.bind-lock-dialog .el-select {
  width: 70%;
}
.el-button {
  font-weight: lighter;
}
.parking-space .bind-lock-dialog .el-select{
  width:100%;
}
</style>
